import React from 'react';
import PageBanner from '../components/PageBanner';

const NEWS = [
  {
    title: 'MEME STORE تطلق خدمة التوصيل السريع في 5 مدن جديدة',
    date: '10 يوليو 2026',
    excerpt: 'توسعة جديدة في شبكة التوصيل السريع لتغطية أكتر من 20 مدينة داخل المملكة بأوقات توصيل أقل.',
  },
  {
    title: 'شراكة استراتيجية مع علامات عالمية لتوسيع تشكيلة الإلكترونيات',
    date: '2 يونيو 2026',
    excerpt: 'اتفاقيات جديدة مع موزعين معتمدين لتوفير أحدث الأجهزة الإلكترونية بأسعار تنافسية وضمان أصلي.',
  },
  {
    title: 'MEME STORE تتجاوز 50 ألف عميل نشط شهرياً',
    date: '15 أبريل 2026',
    excerpt: 'نمو ملحوظ في قاعدة العملاء مدفوع بتحسينات في تجربة التطبيق وسرعة الشحن.',
  },
  {
    title: 'إطلاق برنامج نقاط الولاء الجديد',
    date: '3 مارس 2026',
    excerpt: 'برنامج مكافآت جديد يتيح للعملاء تجميع نقاط مع كل عملية شراء واستبدالها بخصومات حصرية.',
  },
];

const News = () => {
  return (
    <div dir="rtl">
      <PageBanner
        eyebrow="آخر الأخبار"
        title="أخبار MEME STORE"
        subtitle="آخر التحديثات والإعلانات الرسمية من فريقنا."
      />

      <div className="container mx-auto px-4 py-14">
        <div className="grid md:grid-cols-2 gap-6">
          {NEWS.map((item) => (
            <article
              key={item.title}
              className="bg-white border border-gray-100 rounded-2xl p-7 shadow-[0_2px_10px_rgba(27,27,31,0.05)] hover:shadow-lg transition-shadow"
            >
              <span className="text-xs font-bold text-[#F2B705] bg-[#F2B705]/10 px-3 py-1 rounded-full">
                {item.date}
              </span>

              <h2 className="text-xl font-bold text-[#1B1B1F] mt-4 mb-3 leading-snug">
                {item.title}
              </h2>

              <p className="text-gray-600 leading-7">{item.excerpt}</p>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default News;
